export default {
  // 標題
  transfer: "轉賬",

  // 高級選項
  advancedOpen: "高級 >>",
  advancedClose: "高級 <<",

  // 表單標籤
  transferDirection: "劃轉方向",
  transactionQuantity: "交易數量",
  currency: "幣種",
  occurrenceTime: "發生時間",

  // 占位符
  pleaseSelectTransferDirection: "請選擇轉賬方向",
  pleaseEnterCurrency: "請輸入幣種",
  startDate: "開始日期",
  endDate: "結束日期",

  // 轉賬方向選項
  inflow: "流入",
  outflow: "流出",
  bidirectional: "雙向",

  // 按鈕
  cancel: "取消",
  save: "保存",

  // 消息提示
  saveSuccess: "保存成功",

  // 時間分隔符
  to: "至",
};
